<template>
    <div class="pa-5">
        <v-card :loading="loading">
            <v-card-text class="d-flex align-justify">
                <v-text-field outlined dense label="Search" v-model="search" hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="subscription_dialog = true">New Subscription</v-btn>
            </v-card-text>
            <v-divider></v-divider>
            <v-data-table
                :headers="headers"
                :items="subscriptions"
                :search="search"
                class="elevation-1"
                >
                <template v-slot:body = {items}>
                    <tbody>
                        <tr
                            v-for="item in items"
                            :key="item.id"
                        >
                            <td><v-btn text small @click="$store.state.user.account_type =='admin' ? viewClients(item) : null;">{{ item.user.name }}</v-btn></td>
                            <td class="pa-2">
                                <v-btn outlined small target="_blank" 
                                    :to="{name : 'Dashboard', params : {code : item.event_code}}"
                                    block>
                                    {{ item.event_code }}
                                </v-btn>
                                <div class="text-center mt-2">
                                    {{ item.hash_tag }}
                                </div>
                                <div class="text-center mt-2">
                                    {{ item.start_date }} - {{ item.end_date }}
                                </div>
                            </td>
                            <td>
                                <div :style="{background : item.theme, width:'20px', height : '20px', borderRadius : '10px'}"></div>
                            </td>
                            <td class="text-center">
                                <v-btn small icon @click="image = item.background; image_dialog=true;">
                                    <v-icon>mdi-image</v-icon>
                                </v-btn>
                            </td>
                            <td class="text-center">
                                <v-btn small icon @click="image = item.banner; image_dialog=true;">
                                    <v-icon>mdi-image</v-icon>
                                </v-btn>
                            </td>
                            <td class="text-center">
                                <v-btn small icon @click="image = item.logo; image_dialog=true;">
                                    <v-icon>mdi-image</v-icon>
                                </v-btn>
                            </td>
                            <td class="text-center">
                                <v-btn small icon @click="viewFrames(item)">
                                    <v-icon>mdi-grid</v-icon>
                                </v-btn>
                            </td>
                            <td>{{ item.enable_message_approval == 1 ? 'Yes' : 'No' }}</td>
                            <td>{{ item.show_timestamp == 1 ? 'Yes' : 'No' }}</td>
                            <td>{{ item.require_email == 1 ? 'Yes' : 'No' }}</td>
                            <td>{{ item.require_mobile == 1 ? 'Yes' : 'No' }}</td>
                            <td>{{ item.rotation_interval ? item.rotation_interval : 5 }} Mins</td>
                            <td class="pt-2 pb-2">
                                <v-btn x-small color="success" dark block
                                    target="_blank"
                                    class="mb-2"
                                    :to="{name: 'ApprovedTestimonials', params : {id : item.subscription_key}}">
                                    Approved
                                </v-btn>
                                <v-btn x-small color="warning" block
                                    target="_blank"
                                    class="mb-2"
                                    :to="{name: 'PendingTestimonials', params : {id : item.subscription_key}}">
                                    Pending
                                </v-btn>
                                <v-btn x-small color="error" block
                                    target="_blank"
                                    :to="{name: 'RejectedTestimonials', params : {id : item.subscription_key}}">
                                    Rejected
                                </v-btn>
                            </td>
                            <td>
                                <v-btn x-small color="primary" text @click="edit(item)">Edit</v-btn>
                                <v-btn x-small color="error" text>Cancel</v-btn>
                            </td>
                            <td>
                                <v-btn x-small color="primary" @click="details = item; qr_code_dialog = true;">View</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="subscription_dialog" width="500">
            <subscription-dialog :data="subscription" @refresh="refreshData" @close="subscription_dialog = false"/>
        </v-dialog>
        <v-dialog v-model="subscription_edit_dialog" width="500">
            <subscription-edit-dialog :subscription="subscription" @refresh="refreshData" @close="subscription_edit_dialog = false"/>
        </v-dialog>
        <v-dialog v-model="image_dialog" width="500">
            <v-card>
                <img :src="image" alt="" width="100%">
            </v-card>
        </v-dialog>
        <v-dialog v-model="qr_code_dialog" width="300">
            <v-card>
                <v-card-text class="text-center pa-2">
                    <a :href="details.link">{{ details.link }}</a>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text class="pa-2 text-center">
                    <img :src="details.qr_code" width="250" >
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="clients_dialog" width="500">
            <v-card>
                <v-card-title>
                    Link Subscription
                </v-card-title>
                <v-card-text class="pa-2">
                    <v-list dense>
                        <v-list-item v-for="c in clients" :key="c.id" @click="transferToClient(c)">
                            <v-list-item-avatar color="grey darken-4">
                                <span class="text-h5 white--text">{{ c.name.substring(0, 1) }}</span>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-subtitle>{{ c.name }}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{ c.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <img :src="details.qr_code" width="300" >
            </v-card>
        </v-dialog>
        <v-dialog max-width="500" v-model="framesDialog">
            <v-card :loading="framesLoading">
                <v-card-title>
                    <span>{{ subscription.event_code }}</span>
                    <v-spacer></v-spacer>
                    <v-btn text small @click="openFramePicker">Add Frame</v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-3">
                    <input type="file" ref="fileFrameInput" style="display:none;" @change="onFramePickerChange">
                    <template v-if="subscription.frames?.length > 0">
                        <ul class="frames-list">
                            <li v-for="frame in subscription.frames">
                                <img height="100" :src="`${baseUrl}/uploads/subscriptions/${subscription.id}/frames/${frame.frame_image}`"></img>
                                <div>
                                    <v-btn x-small text color="error" @click="deleteFrame(frame.id)">delete</v-btn>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        No Frames found.
                    </template>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text small @click="framesDialog = false">close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import SubscriptionDialog from '@/views/admin/dialog/SubscriptionDialog.vue';
import SubscriptionEditDialog from '@/views/admin/dialog/SubscriptionEditDialog.vue';
import axios from 'axios';
export default {
    name : 'SubscriptionsView',
    components : {
        SubscriptionDialog,
        SubscriptionEditDialog
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        openFramePicker() {
            this.$refs.fileFrameInput.click();
        },
        async getSubscriptionById(id) {
            let response = await axios({
                url : `${process.env.VUE_APP_API_URL}/subscriptions/${id}/details`,
                method : 'GET',
                headers : {
                    Authorization : 'Bearer ' + this.$store.state.user.token
                }
            });

            return response.data;
        },
        async onFramePickerChange(e) {
            this.framesLoading = true;
            const file = e.target.files[0]
            if (!file) return

            try {
                const formData = new FormData();
                formData.append('file', file);

                let response = await axios({
                    url : `${process.env.VUE_APP_API_URL}/subscriptions/${this.subscription.id}/frames`,
                    method : 'POST',
                    data : formData,
                    headers : {
                        Authorization : 'Bearer ' + this.$store.state.user.token
                    }
                });

                this.subscription = await this.getSubscriptionById(this.subscription.id);

                this.framesLoading = false;
            } catch (error) {
                this.framesLoading = false;
            }
        },
        edit(details) {
            this.subscription = details;
            console.log(details);
            this.subscription_edit_dialog = true;
        },
        async deleteFrame(id) {
            if(confirm('Are you sure you want to delete this frame?')) {
                try {
                    this.framesLoading = true;
                    let response = await axios({
                        url : process.env.VUE_APP_API_URL + '/subscriptions/' + this.subscription.id + '/frames/' + id,
                        method : 'DELETE',
                        headers : {
                            Authorization : 'Bearer ' + this.$store.state.user.token
                        }
                    });
                    
                    this.subscription = await this.getSubscriptionById(this.subscription.id);
                    this.framesLoading = false;
                } catch (error) {
                    this.framesLoading = false;
                }
            }
        },
        refreshData() {
            this.loading = true;
            axios({
                url : this.$store.state.api_url + '/subscriptions',
                method : 'GET',
                headers : {
                    Authorization : 'Bearer ' + this.$store.state.user.token
                }
            }).then(res => {
                this.subscriptions = res.data;
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            });
        },
        viewClients(subscription) {
            this.subscription = subscription;
            this.clients_dialog = true;
            axios({
                url : this.$store.state.api_url + '/admin/clients',
                method : 'GET',
                headers : {
                    Authorization : 'Bearer ' + this.$store.state.user.token
                }
            }).then(res => {
                this.clients = res.data;
            });
        },
        viewFrames(subscription) {
            this.subscription = {...subscription};
            this.framesDialog = true;
        },
        transferToClient(c) {
            axios({
                url : this.$store.state.api_url + '/subscriptions/'+ this.subscription.id +'/transfer',
                method : 'POST',
                data : {'id' : c.id},
                headers : {
                    Authorization : 'Bearer ' + this.$store.state.user.token
                }
            }).then(res => {
                this.clients_dialog = false;
                this.refreshData();
            });
        }
    },
    data() {
        return {
            baseUrl : process.env.VUE_APP_BASE_URL,
            framesLoading : false,
            loading : false,
            details : {},
            search : '',
            qr_code_dialog : false,
            subscription_dialog : false,
            subscription_edit_dialog : false,
            image_dialog : false,
            image : null,
            subscriptions : [],
            subscription : {},
            clients_dialog : false,
            framesDialog : false,
            clients : [],
            headers : [
                {
                    text : 'Subscriber',
                },
                {
                    text : 'Event Code',
                    value : 'event_code',
                    sortable : true,
                    align : 'center'
                },
                {
                    text : 'Theme',
                    value : 'theme',
                    sortable : false
                },
                {
                    text : 'Background',
                    value : 'background',
                    sortable : false
                },
                {
                    text : 'Banner',
                    value : 'banner',
                    sortable : false
                },
                {
                    text : 'Logo',
                    value : 'logo',
                    sortable : false
                },
                {
                    text : 'Frames',
                    value : 'frames',
                    sortable : false
                },
                {
                    text : 'Requires Approval',
                    value : 'enable_message_approval'
                },
                {
                    text : 'Display Timestamp',
                    value : 'show_timestamp'
                },
                {
                    text : 'Require Email',
                    value : 'require_email'
                },
                {
                    text : 'Require Mobile #',
                    value : 'require_mobile'
                },
                {
                    text : 'Rotation Interval',
                    value : 'rotation_interval'
                },
                {
                    text : 'Wall Posts',
                },
                {
                    text : 'Actions',
                },
                {
                    text : 'QR Code',
                }
            ]
        }
    }
}
</script>
<style scoped>
    .frames-list {
        padding : 0px;
    }
    .frames-list li{
        display: inline-block;
        text-align: center;
        padding: 10px;
    }
</style>